var UserAffinityTelemetryEventNames = /* @__PURE__ */ ((UserAffinityTelemetryEventNames2) => {
  UserAffinityTelemetryEventNames2["App_UserAffinity_getDefaultWorkspaceId"] = "App_UserAffinity_getDefaultWorkspaceId";
  UserAffinityTelemetryEventNames2["App_UserAffinity_setUserAffinity"] = "App_UserAffinity_setUserAffinity";
  UserAffinityTelemetryEventNames2["App_UserAffinity_clearUserAffinity"] = "App_UserAffinity_clearUserAffinity";
  UserAffinityTelemetryEventNames2["App_UserAffinity_setlastWorkspaceId"] = "App_UserAffinity_setlastWorkspaceId";
  UserAffinityTelemetryEventNames2["App_UserAffinity_setLastExperimentationGroup"] = "App_UserAffinity_setLastExperimentationGroup";
  return UserAffinityTelemetryEventNames2;
})(UserAffinityTelemetryEventNames || {});
export {
  UserAffinityTelemetryEventNames
};
//# sourceMappingURL=UserAffinityTelemetryEventNames.js.map
